import React from 'react';
import { Box, Container, Typography } from '@mui/material';

const topClients = [
  "Hindustan Coca-Cola", 
  "Indian Navy", 
  "ITC Fortune Hotels", 
  "Govt of AP (APTIDCO)", 
  "Bottlers Nepal Ltd", 
  "Superior Drinks", 
  "Ludhiana Beverages", 
  "Brindavan Bottlers"
];

const Clients = () => {
  return (
    <Box sx={{ py: 8, bgcolor: 'white', overflow: 'hidden' }}>
      <Container maxWidth="lg">
        
        <Typography 
          variant="overline" 
          align="center" 
          display="block" 
          sx={{ 
            color: '#2e7d32', 
            letterSpacing: 3, 
            mb: 6, 
            fontWeight: 800,
            fontSize: '0.9rem' 
          }}
        >
          TRUSTED PARTNERS
        </Typography>

        <Box
          sx={{
            width: "100%",
            overflow: "hidden",
            position: "relative",
            maskImage: 'linear-gradient(to right, transparent, black 10%, black 90%, transparent)',
            WebkitMaskImage: 'linear-gradient(to right, transparent, black 10%, black 90%, transparent)',
          }}
        >
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              gap: 10, 
              width: "max-content",
              animation: "scrollText 35s linear infinite",
              "&:hover": {
                animationPlayState: "paused",
              },
            }}
          >
            
            {[...topClients, ...topClients, ...topClients].map((client, index) => (
              <Typography 
                key={index}
                variant="h5" 
                sx={{ 
                  color: '#90a4ae', // 
                  fontWeight: 800, 
                  textTransform: 'uppercase', 
                  fontSize: { xs: '1.1rem', md: '1.5rem' }, // 
                  whiteSpace: 'nowrap',
                  cursor: 'default',
                  transition: 'all 0.3s ease',
                  '&:hover': {
                    color: 'transparent',
                    background: 'linear-gradient(90deg, #0d47a1, #2e7d32)',
                    backgroundClip: 'text',
                    transform: 'scale(1.05)'
                  }
                }}
              >
                {client}
              </Typography>
            ))}
          </Box>
        </Box>

      </Container>

      <style>
        {`
          @keyframes scrollText {
            0% { transform: translateX(0); }
            100% { transform: translateX(-33.33%); } 
          }
        `}
      </style>
    </Box>
  );
};

export default Clients;